
const lgsxxlargeQuestionStandardTypes = [
    {
      key: "lgs2",
      label: "LGS 2",
    },
  ];

export default lgsxxlargeQuestionStandardTypes;